import React from 'react';
import Chart from 'react-apexcharts';

const StateWiseBarChart = ({ stateWiseData }) => {
    const categories = stateWiseData?.map(item => item?.state);
    const seriesData = stateWiseData?.map(item => item?.count);

    // Check if all values in `seriesData` are 0
    const isAllZero = seriesData.every(count => count === 0);

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        xaxis: {
            categories,
            labels: {
                style: { fontSize: "14px", fontWeight: "500", colors: "#666" },
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "45%",
            },
        },
        dataLabels: { enabled: false },
        legend: {
            position: "bottom",
            fontSize: "14px",
            labels: { colors: "#333" },
        },
        grid: {
            borderColor: "#E0E0E0",
            strokeDashArray: 4,
        },
        colors: isAllZero ? ["#000000"] : ["#1E90FF", "#87CEEB"], // Black bars if all data is 0
        fill: {
            type: "gradient",
            gradient: {
                type: "vertical",
                gradientToColors: isAllZero ? ["#000000"] : ["#87CEEB"],
                stops: [0, 100],
            },
        },
    };

    const series = [{ name: 'Orders', data: seriesData.length > 0 ? seriesData : [0] }];

    return (
        <div className="w-full">
            <Chart
                options={options}
                series={series}
                type="bar"
                width="100%"
                height={300}
            />
        </div>
    );
};

export default StateWiseBarChart;






// import React from 'react';
// import Chart from 'react-apexcharts';

// const StateWiseBarChart = ({ stateWiseData }) => {
//     // stateWiseData = [
//     //   { state: "Gujarat", count: 22 },
//     //   { state: "Maharashtra", count: 4 },
//     //   { state: "Rajasthan", count: 1 },
//     //   ...
//     // ]

//     const categories = stateWiseData?.map(item => item?.state);
//     const seriesData = stateWiseData?.map(item => item?.count);

//     const options = {
//         chart: {
//             type: "bar",
//             toolbar: { show: false }, // Hides extra UI
//         },
//         xaxis: {
//             categories, // Assuming 'categories' is passed as a prop or defined elsewhere
//             labels: {
//                 style: { fontSize: "14px", fontWeight: "500", colors: "#666" }, // Better text visibility
//             },
//         },
//         plotOptions: {
//             bar: {
//                 horizontal: false,
//                 columnWidth: "45%", // Slimmer bars for a cleaner look
//                 // borderRadius: 6, // Rounded bar corners
//             },
//         },
//         dataLabels: { enabled: false },
//         legend: {
//             position: "bottom",
//             fontSize: "14px",
//             labels: { colors: "#333" }, // Darker text for readability
//         },
//         grid: {
//             borderColor: "#E0E0E0", // Subtle grid lines
//             strokeDashArray: 4, // Dashed grid lines for elegance
//         },
//         colors: ["#1E90FF", "#87CEEB"], // Gradient blue colors
//         fill: {
//             type: "gradient",
//             gradient: {
//                 // shade: "light",
//                 type: "vertical",
//                 gradientToColors: ["#87CEEB"], // Lighter blue for a clean transition
//                 stops: [0, 100],
//             },
//         },
//     };
//     const series = [
//         {
//             name: 'Orders',
//             data: seriesData
//         }
//     ];

//     return (
//         <div className="w-full">
//             <Chart
//                 options={options}
//                 series={series}
//                 type="bar"
//                 width="100%"
//                 height={300}
//             />
//         </div>
//     );
// }

// export default StateWiseBarChart;
